export const API_BASE_URL = 'https://skilltherapyai.com/api_master/api/';
// export const API_BASE_URL = 'http://localhost:8000/';

export const PAYMENT_RETURN_URL = 'https://skilltherapyai.com/payment-status';
// export const PAYMENT_RETURN_URL = 'http://localhost:3000/payment-status';
